import { render } from "./AppPdfPreview.vue?vue&type=template&id=5fab3ad6&scoped=true&ts=true"
import script from "./AppPdfPreview.vue?vue&type=script&lang=ts"
export * from "./AppPdfPreview.vue?vue&type=script&lang=ts"

import "./AppPdfPreview.vue?vue&type=style&index=0&id=5fab3ad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fab3ad6"]])

export default __exports__